<article>
  <header (click)="handleToggleAccordion()">
    <strong>Filtro</strong>
    <img
      class="accordion-img"
      [ngClass]="{ 'rotate-animation': !isOpen }"
      src="assets/icons/arrow.svg"
    />
  </header>

  <main [ngClass]="{ 'is-collapsed': !isOpen }">
    <div main class="main">
      <div class="grid-content">
        <app-input
          label="Protocolo"
          placeholder="Digite o protocolo"
          [control]="form.controls.protocolNumber"
          [disabled]="false"
        ></app-input>

        <app-select-multi
          label="Atendentes"
          placeholder="Selecione múltiplos atendentes"
          [multiControl]="form.controls.attendants"
          [options]="attendants"
          [multi]="true"
          [disabled]="loadingAttendants"
          [loading]="loadingAttendants"
          [selected]="selectedAttendants"
          [isSearch]="true"
          [loadingSearch]="loadingSearchAttendants"
          [isDinamicSearch]="true"
          (searchValueEmmiter)="getAttendants($event)"
          [isPaged]="true"
          [loadingPage]="loadingMoreAttendants"
          (scrollEndedEmmiter)="getMoreAttendants()"
          errorMessage="campo obrigatório"
        >
        </app-select-multi>

        <app-select-multi
          label="Categorias"
          placeholder="Selecione múltiplas categorias"
          [multiControl]="form.controls.categories"
          [selected]="selectedCategories"
          [options]="categories"
          [multi]="true"
          [disabled]="loadingCategories"
          [loading]="loadingCategories"
          (searchValueEmmiter)="getCategories($event)"
          [isPaged]="true"
          [isSearch]="true"
          [isDinamicSearch]="true"
          [loadingSearch]="loadingSearchCategories"
          [loadingPage]="loadingMoreCategories"
          (scrollEndedEmmiter)="getMoreCategories()"
          errorMessage="campo obrigatório"
        >
        </app-select-multi>

        <div class="period">
          <app-input
            label="Data de Atendimento"
            placeholder="De"
            [control]="form.controls.initialDate"
            [disabled]="false"
            [type]="InputTypeEnum.date"
          ></app-input>
          <app-input
            label=""
            placeholder="Até"
            [control]="form.controls.finalDate"
            [disabled]="false"
            [type]="InputTypeEnum.date"
          ></app-input>
        </div>

        <app-select-multi
          label="Status"
          placeholder="Selecione múltiplos status"
          [multiControl]="form.controls.status"
          [options]="status"
          [selected]="selectedStatus"
          property="Type"
          [disabled]="false"
          [multi]="true"
        ></app-select-multi>

        <app-select-multi
          label="Tipos"
          placeholder="Selecione múltiplos tipos"
          [multiControl]="form.controls.types"
          [options]="types"
          [selected]="selectedTypes"
          property="types"
          [disabled]="false"
          [multi]="true"
        ></app-select-multi>

        <app-select-multi
          label="Clientes"
          placeholder="Selecione múltiplos clientes"
          [multiControl]="form.controls.clients"
          [options]="clients"
          [multi]="true"
          [disabled]="loadingClients"
          [loading]="loadingClients"
          [isSearch]="true"
          [selected]="selectedClients"
          [loadingSearch]="loadingSearchClients"
          [isDinamicSearch]="true"
          (searchValueEmmiter)="getClients($event)"
          [loadingPage]="loadingMoreClients"
          (scrollEndedEmmiter)="getMoreClients()"
          [isPaged]="true"
          errorMessage="campo obrigatório"
        >
        </app-select-multi>
      </div>
    </div>

    <hr />

    <div footer class="footer">
      <app-secondary-button
        (click)="clear()"
        (keydown.enter)="clear()"
        label="Limpar"
        [color]="ButtonColorEnum.warning"
        [icon]="'assets/icons/trash.svg'"
        [enabled]="true"
        [widthFull]="true"
      >
      </app-secondary-button>
      <app-primary-button
        [label]="'Filtrar'"
        [color]="ButtonColorEnum.common"
        [loading]="isLoading"
        (clickFunc)="search()"
      ></app-primary-button>
    </div>
  </main>
</article>
